import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchServices } from "../../../store/actions/service";
import { setForm } from "../../../store/actions/form";
import { fetchPromotions } from "../../../store/actions/promotion";
import { setPromotionInfo } from "../../../store/actions/promotionInfo";
import {
  AVAILABLE_PREWIRED,
  AVAILABLE_NOT_PREWIRED
} from "../../../data/status";
import { fetchTimeslots, fetchCustomTimeSlots } from "../../../store/actions/timeslots";
import { googleTracking } from '../../../util';
import ServiceSelect from 'fs-service-select';
import {shouldProcessAsUnscheduledLead} from '../../../util';

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
  }

  transitionBack() {
    const { changeStep } = this.props;
    this.setState({
      animation: "fade left",
      visible: false
    });
    setTimeout(() => {
      changeStep(1, "fade right");
    }, 400);
  }

  transitionNext(output) {
    const {
      status,
      promotion,
      fetchTimeslots,
      fetchCustomTimeSlots,
      setForm,
      bid,
      setPromotionInfo
    } = this.props;

    const promotionId = output.promotion.id;

    setForm({
      unlimitedInternetObj: output.unlimitedInternet,
      wifiRouterObj: output.wifiRouter,
      homePhoneObj: output.homePhone,
      promotionObj: output.promotion,
      unlimitedInternet: output.unlimitedInternet.scid,
      wifiRouter: output.wifiRouter.scid,
      homePhone: output.homePhone.scid || null,
      promotion: output.promotion.id || null
    });

    if(output.promotion.id)
    {
      setPromotionInfo({ promo_code: output.promotion.code});
    }
   
    if (shouldProcessAsUnscheduledLead(output.unlimitedInternet.code)) {
      setForm({ otherTimeSlot: true });
      this.gotToStep3();
      return;
    }

    if (status === AVAILABLE_PREWIRED) {
      this.addGoogleTracking('prewired', output.unlimitedInternet, output.wifiRouter, output.homePhone);
      this.gotToStep4();
    } else if (status === AVAILABLE_NOT_PREWIRED) {
      this.addGoogleTracking('not-prewired', output.unlimitedInternet, output.wifiRouter, output.homePhone);
      if (promotion.length > 0) {
        fetchTimeslots(promotionId).then(response => {
          if (response === true) {
            this.goToStep7();
          } else {
            fetchCustomTimeSlots(bid).then(response => {
              if (response === true) {
                this.goToStep7();
              } else {
                setForm({ otherTimeSlot: true });
                this.gotToStep3();
              }
            });
          }
        });
      } else {
        fetchCustomTimeSlots(bid).then(response => {
          if (response === true) {
            this.goToStep7();
          } else {
            setForm({ otherTimeSlot: true });
            this.gotToStep3();
          }
        });
      }
    }
  }

  goToStep7() {
    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });
    setTimeout(() => {
      this.props.changeStep(7, "fade left");
    }, 400);
  }

  gotToStep3() {
    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });

    setTimeout(() => {
      this.props.changeStep(3, "fade left");
    }, 400);
  }
  gotToStep4() {
    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });

    setTimeout(() => {
      this.props.changeStep(4, "fade left");
    }, 400);
  }


  componentDidMount() {
    const { bid, fetchServices, fetchPromotions, status } = this.props;

    if (status === AVAILABLE_PREWIRED) {
      googleTracking({ 'event': 'virtualPageview', 'pageview': '/prewired/step3/select-package-options' });
    }
    else if (status === AVAILABLE_NOT_PREWIRED) {
      googleTracking({ 'event': 'virtualPageview', 'pageview': '/not-prewired/step3/select-package-options' });
    }

    this.setState({
      visible: true
    });
    fetchServices(bid);
    fetchPromotions(bid);
  }

  addGoogleTracking(flow, unlimitedInternetObj, wifiRouterObj, homePhoneObj) {
    googleTracking({
      'event': 'GAevent',
      'eventCategory': 'package-options-submission',
      'eventAction': 'submit',
      'eventLabel': flow,
      'unlimited-internet-option': unlimitedInternetObj.name || '',
      'wi-fi-router': wifiRouterObj.name || '',
      'home-phone': homePhoneObj.name || ''
    })
  }

  render() {
    const {
      visible,
      animation,
    } = this.state;
    const {
      service,
      promotion,
      shipping,
      status,
      unlimitedInternetObj,
      wifiRouterObj,
      homePhoneObj,
      promotionObj
    } = this.props;

    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <ServiceSelect
          visible={visible} 
          animation={animation}
          internet={service.internet}
          phone={service.phone}
          wifiRouter={service.wifiRouter}
          shipping={shipping}
          promotion={promotion}
          status={status}
          next={this.transitionNext}
          selectedInternet={unlimitedInternetObj}
          selectedWifiRouter={wifiRouterObj}
          selectedPromotion={promotionObj}
          selectedHomePhone={homePhoneObj}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    bid: state.connection.bid,
    service: state.service,
    promotion: state.promotion,
    status: state.connection.status,
    shipping: state.service.shipping,
    unlimitedInternetObj: state.form.unlimitedInternetObj,
    wifiRouterObj: state.form.wifiRouterObj,
    homePhoneObj: state.form.homePhoneObj,
    promotionObj: state.form.promotionObj
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchServices: bid => dispatch(fetchServices(bid)),
    setForm: data => dispatch(setForm(data)),
    fetchPromotions: bid => dispatch(fetchPromotions(bid)),
    fetchTimeslots: promotion => dispatch(fetchTimeslots(promotion)),
    fetchCustomTimeSlots: bid => dispatch(fetchCustomTimeSlots(bid)),
    setPromotionInfo: data => dispatch(setPromotionInfo(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step2);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/Step2.js